// extracted by mini-css-extract-plugin
export default {"brand":"brand-item_brand__WyM-V","link":"brand-item_link__a3R1e","img":"brand-item_img__jzaz9"};